module.exports = __webpack_public_path__ + "images/sprites/ui/circle_arrow_gr_wh_160ab1de8b8e4fa84a3c8f21f45c8fd6.png";